import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"middle-align"},[_c(VBtn,{attrs:{"text":""},on:{"click":function($event){return _vm.$router.back()}}},[_c(VIcon,{attrs:{"left":""}},[_vm._v("mdi-arrow-left")])],1),_c('span',{staticClass:"text-h5"},[_vm._v(" "+_vm._s(_vm.$t(_vm.$route.meta.title))+" ")]),_c(VSpacer),_vm._t("buttons")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }